import React from 'react';
import { Link } from 'react-router-dom';
import '../Styles/Blog.css';

const BlogFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="blog-footer">
      <div className="blog-footer-container">
        {/* Footer Brand */}
        <div className="blog-footer-section">
          <h3 className="footer-brand">PP Studio</h3>
          <p className="footer-tagline">
            Insights on contracts, freelancing, and professional relationships.
          </p>
        </div>

        {/* Quick Links */}
        <div className="blog-footer-section">
          <h4 className="footer-heading">Explore</h4>
          <ul className="footer-links">
            <li><Link to="/journey">Journey</Link></li>
            <li><Link to="/skills">Skills</Link></li>
            <li><Link to="/cases">Sample Agreements</Link></li>
            <li><Link to="/contract-tips">Contract Tips</Link></li>
          </ul>
        </div>

        {/* Blog Links */}
        <div className="blog-footer-section">
          <h4 className="footer-heading">The PP Edit</h4>
          <ul className="footer-links">
            <li><Link to="/blog">All Articles</Link></li>
            <li><Link to="/podcast">Podcast</Link></li>
            <li><Link to="/work-with-me">Work With Me</Link></li>
          </ul>
        </div>

        {/* Connect */}
        <div className="blog-footer-section">
          <h4 className="footer-heading">Connect</h4>
          <ul className="footer-links">
            <li><a href="mailto:hello@ppstudio.com">hello@ppstudio.com</a></li>
            {/* Add your social links here */}
            {/* <li><a href="https://linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer">LinkedIn</a></li> */}
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="blog-footer-bottom">
        <p>&copy; {currentYear} PP Studio. All rights reserved.</p>
        <p className="footer-legal-links">
          <Link to="/privacy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
};

export default BlogFooter;
